// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2fwaF","upload":"Small_upload__2oMDA","imageWrap":"Small_imageWrap__THdIc","removeBtn":"Small_removeBtn__2Sqn7"};